export default {
    props: {
        contentTemplate: {
            type: String,
            default: undefined,
            kComposite: 'content.template'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-window-vue-wrapper/src/KendoWindow/Content.js